var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundSeafoammin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1444,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M648.283 331.227C553.781 240.4 480.484 127.733 436.474 1.333h-515.48C-6.644 125.573 34.86 270.027 34.86 424.187c0 379.12-250.779 699.623-595.526 804.903v213.6H557.995c-105.598-140.61-168.172-315.36-168.172-504.743 0-238.374 99.17-453.574 258.46-606.694v-.026z",
    fill: "url(#prefix__paint0_linear_1888_50812)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M647.966 331.224c151.289-145.413 356.804-234.8 583.234-234.8 226.42 0 431.94 89.414 583.23 234.8 77.43-74.426 140.64-163.52 185.19-262.8V1.331H436.157c44.01 126.4 117.334 239.093 211.809 329.893z",
    fill: "url(#prefix__paint1_linear_1888_50812)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.86 424.187C34.86 270.027-6.643 125.6-79.007 1.333h-481.659V1229.07C-215.919 1123.81 34.86 803.28 34.86 424.16v.027z",
    fill: "url(#prefix__paint2_linear_1888_50812)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.74 331.227c-151.29 145.413-356.8 234.8-583.23 234.8-226.42 0-431.938-89.414-583.227-234.8-159.317 153.12-258.46 368.32-258.46 606.693 0 189.36 62.574 364.11 168.172 504.75H1905.06c37.29-49.66 69.19-103.55 94.87-160.86V594.053c-44.51-99.306-107.76-188.373-185.19-262.8v-.026z",
    fill: "url(#prefix__paint3_linear_1888_50812)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M648.283 331.227c151.289 145.413 356.807 234.8 583.227 234.8 226.43 0 431.94-89.414 583.23-234.8-151.29-145.414-356.8-234.8-583.23-234.8-226.42 0-431.938 89.413-583.227 234.8z",
    fill: "url(#prefix__paint4_linear_1888_50812)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_1888_50812",
    x1: 915.272,
    y1: 1663.59,
    x2: -852.131,
    y2: -66.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#00EBC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_1888_50812",
    x1: 313.716,
    y1: 194.308,
    x2: 2783.82,
    y2: 194.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#00EBC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_1888_50812",
    x1: -1198.16,
    y1: 795.863,
    x2: 95.453,
    y2: 795.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#00EBC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_1888_50812",
    x1: 1194.76,
    y1: 1743.45,
    x2: 1194.76,
    y2: 274.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#00EBC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_1888_50812",
    x1: 803.478,
    y1: 678.747,
    x2: 1389.06,
    y2: -327.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#00EBC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#029DF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSeafoammin);
export default __webpack_public_path__ + "static/media/background-seafoam.min.dafd4d0438cf1b5416da17c6a4974038.svg";
export { ForwardRef as ReactComponent };